<div class="item-grid-container px-3">
    <ul class="list-inline grid-top-actions search-holder mb-3">
      <li class="list-inline-item ">
        <input
          type="text"
          placeholder="{{ 'pages.newRetailer.search' | translate }}"
          matInput
          class="
            rounded-pill
            px-3
            py-2
            mb-0
            border-0
            bg-light
            w-100
            me-0
            input-search
            ms-3
          "
          (keyup)="quickSearch()"
          [(ngModel)]="searchValue"
        />
        <i
          color="primary"
          class="search-icon-holder"
          matSuffix
          mat-icon-button
          aria-label="Search"
        >
          <mat-icon>search</mat-icon>
        </i>
      </li>
    </ul>
    <div class="report-grid">
      <ag-grid-angular
        style="width: 100%; height: 65vh"
        class="ag-theme-material"
        [rowHeight]="40"
        [enableFilter]="true"
        [enableSorting]="true"
        [enableColResize]="true"
        [rowSelection]="'single'"
        [rowData]="promoCodeHistoryData"
        (gridReady)="onGridReady($event)"
        [columnDefs]="promoCodeHistoryColumnDef"
      >
      </ag-grid-angular>
    </div>
  </div>